import { states } from '../consts/stateList'

export default function StateSelector({
  handleOnChangeState,
  selectedState,
}: {
  handleOnChangeState: (_event: React.ChangeEvent<HTMLSelectElement>) => void
  selectedState: string
}) {
  return (
    <div>
      <select
        value={selectedState}
        name={'stateSelector'}
        onChange={handleOnChangeState}
        style={{ backgroundColor: 'rgb(251,230,168)' }}
      >
        {states.map((state) => {
          return (
            <>
              <option
                key={`ss-${state.abbreviation}`}
                value={state.abbreviation}
              >
                {state.abbreviation} - {state.name}
              </option>
            </>
          )
        })}
      </select>
    </div>
  )
}
